import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-carito-da-silva-cv',
  templateUrl: './carito-da-silva-cv.component.html',
  styleUrls: ['./carito-da-silva-cv.component.scss']
})
export class CaritoDaSilvaCVComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
